import { render, staticRenderFns } from "./ContractDetails.vue?vue&type=template&id=3063fe30&scoped=true"
import script from "./ContractDetails.vue?vue&type=script&lang=js"
export * from "./ContractDetails.vue?vue&type=script&lang=js"
import style0 from "./ContractDetails.vue?vue&type=style&index=0&id=3063fe30&prod&lang=css"
import style1 from "./ContractDetails.vue?vue&type=style&index=1&id=3063fe30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3063fe30",
  null
  
)

export default component.exports